import { baseActions, baseMutations } from '../base'
import { formatDate } from '@/helpers/dateHelper'

const initialState = () => {
  return {
    module: 'towns',
    model: 'town',
    loading: false,
    list: [],
    selectList: [],
    selected: {
      active: true,
      name: {},
      provinceId: {},
    },
    idSelected: '',
    filters: {},
    pagination: {
      hasMore: false,
      page: 1,
      rowsPerPage: 10,
      totalItems: 0,
    },
  }
}

const state = initialState()

const getters = {
  selectList(state) {
    return state.selectList
  },
  formatedList(state) {
    return state.list.map((item) => {
      let result = {
        _id: item._id,
        active: item.active,
        name: item.name,
        province: item.provinceId ? item.provinceId.name : '-',
        createdAt: formatDate(item.createdAt, true),
        createdBy: item.createdBy
          ? item.createdBy.name + ' ' + item.createdBy.lastname1
          : '-',
      }
      return result
    })
  },
}

const actions = {
  ...baseActions,
}

const mutations = {
  ...baseMutations,
  resetState(state) {
    const newState = initialState()
    Object.keys(state).forEach((key) => {
      delete state[key]
    })
    Object.assign(state, newState)
  },
  reset(state) {
    state.selected = initialState().selected
    state.idSelected = ''
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
